import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PickupFilterService } from '../../shared/filter/pickup-filter.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { InvoiceQuery } from '../../../models/invoice-query';
import { FilterAssist } from '../../../models/filter-assist';
import { debounceTime, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { pickupTableAddAssist, pickupTableRemoveAssist } from '../../../store/pickup-table/pickup-table.actions';
import { selectPickupTableQuery } from 'src/app/store/pickup-table/pickup-table.state';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { IconComponent } from '../../shared/icon/icon.component';
import { AsyncPipe } from '@angular/common';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'app-pickup-table-filter',
    templateUrl: './pickup-table-filter.component.html',
    styleUrls: ['./pickup-table-filter.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatChipGrid, MatChipRow, MatChipRemove, IconComponent, MatInput, MatChipInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, AsyncPipe]
})
export class PickupTableFilterComponent implements OnInit {

    @ViewChild('termsInput') termsInput: ElementRef<HTMLInputElement>;

    searchForm = new UntypedFormGroup({
        terms: new UntypedFormControl('')
    });

    constructor(private pickupFilterService: PickupFilterService, private store: Store<AppState>) {
    }

    query$: Observable<InvoiceQuery> = this.store.select(selectPickupTableQuery);
    activeAssists$: Observable<FilterAssist[]> = this.query$.pipe(
        switchMap((query) => this.pickupFilterService.activeAssists(query))
    );
    offeredAssists$: Observable<FilterAssist[]> = this.searchForm.valueChanges.pipe(
        debounceTime(200),
        map(form => form.terms),
        filter(terms => typeof terms === 'string'),
        mergeMap(terms => this.pickupFilterService.autocompleteTerms(terms))
    );

    ngOnInit(): void {
    }

    onAssistSelection(assist: FilterAssist): void {
        this.store.dispatch(pickupTableAddAssist({ id: assist.id, parameter: assist.parameter }));
        this.termsInput.nativeElement.value = '';
        this.searchForm.get('terms').setValue('');
    }

    onRemoveAssist(id: string): void {
        this.store.dispatch(pickupTableRemoveAssist({ id }));
    }
}
